import React, { Component } from "react";
import { connect } from "react-redux";
import { getKasm } from "../../actions/actionKasm";
import { destroyKasms,setKasmPageInfo } from "../../actions/actionDashboard";
import { Link } from "react-router-dom";
import DataTable from "../../components/Table/Table"
import {
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Card,
  CardBody,
  CardHeader,
} from "reactstrap";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import { NotificationManager } from "react-notifications";
import "react-table/react-table.css";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../components/Breadcrumb/BreadCrumbCompo";
import moment from "moment";
import "moment-duration-format";

const routes = [
  { name: "Home", path: "/userdashboard", isActive: false },
  { name: "Kasms", path: "/kasm", isActive: true },
];

class Kasms extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      pages: 1,
      kasmId: null,
      deleteClicked: false,
    };

    this.deleteConfirm = this.deleteConfirm.bind(this);
    this.deleteKasmAction = this.deleteKasmAction.bind(this);
    this.handleDeleteSuccess = this.handleDeleteSuccess.bind(this);
    this.handleDeleteError = this.handleDeleteError.bind(this);
    this.cancelDelete = this.cancelDelete.bind(this);
  }

  componentDidMount() {
    this.props.getKasm();
  }

  deleteConfirm(kasmId) {
    this.setState({ modal: !this.state.modal, kasmId: kasmId });
  }

  cancelDelete() {
    this.setState({ modal: !this.state.modal });
  }

  deleteKasmAction() {
    this.setState({ deleteClicked: true });
    this.props
      .destroyKasms(this.state.kasmId)
      .then(() => this.handleDeleteSuccess())
      .catch(() => this.handleDeleteError());
  }

  handleDeleteSuccess() {
    const { destroyKasmsErrorMessage } = this.props;
    if (destroyKasmsErrorMessage) {
      NotificationManager.error(
        destroyKasmsErrorMessage,
        "Failed to Delete Session",
        3000
      );
    } else {
      NotificationManager.success(
        "Session Deleted Successfully",
        "Delete Session",
        3000
      );
      this.setState({ modal: false, deleteClicked: false });
      this.props.getKasm();
    }
  }

  handleDeleteError() {
    const { destroyKasmsError } = this.props;
    if (destroyKasmsError) {
      NotificationManager.error(
        destroyKasmsError,
        "Failed to Delete Session",
        3000
      );
      this.props.history.push("/kasm");
    } else {
      NotificationManager.error("Failed to Delete Session", "Delete Session", 3000);
      this.props.history.push("/kasm");
    }
  }

  render() {
    if (this.props.getKasmLoading) {
      return (
        <div>
          <LoadingSpinner />
        </div>
      );
    }

    const { kasms } = this.props;

    const tableColumns = [
      {
        type: "text",
        name: "Kasm Id",
        accessor: "kasm_id",
        filterable: true,
        sortable: true,
      },
      {
        type: "text",
        name: "Image",
        accessor: "image.friendly_name",
        filterable: true,
        sortable: true,
        cell: (data) => (
          <div>
            <Link to={"/viewimage/" + data.original.image_id}>
              {data.original.image.friendly_name}
            </Link>
          </div>
        ),
      },
      {
        type: "text",
        name: "User",
        accessor: "user.username",
        filterable: true,
        sortable: true,
        cell: (data) => (
          <div>
            <Link to={"/viewuser/" + data.original.user_id}>
              {data.original.user.username}
            </Link>
          </div>
        ),
      },
      {
        type: "text",
        name: "Status",
        accessor: "operational_status",
        filterable: true,
        sortable: true,
      },
      {
        type: "text",
        name: "Last Active",
        accessor: "keepalive_date",
        filterable: true,
        sortable: true,
        cell: (data) => {
          if (!data.original.user_id) {
            return "--";
          }

          const now = moment.utc(data.original.current_time);
          const then = moment.utc(data.original.created_date);
          const elapsedTime = moment.duration(now.diff(then));

          if (elapsedTime.asMinutes() < 5) {
            return <span className="text-success">Logged In</span>
          }

          return elapsedTime.format("hh:mm:ss", { trim: false });
        },
      },
      {
        type: "text",
        name: "Agent",
        accessor: "server.hostname",
        filterable: true,
        sortable: true,
        cell: (data) => (
          <div>
            <Link to={"/viewagent/" + data.original.server_id}>
              {data.original.server.hostname}
            </Link>
          </div>
        ),
      },
      {
        type: "text",
        name: "Zone",
        accessor: "server.zone_name",
        filterable: true,
        sortable: true,
      },
      {
        type: "text",
        name: "Container IP",
        accessor: "container_ip",
        filterable: true,
        sortable: true,
      },
      {
        type: "text",
        name: "Uptime",
        accessor: "created_date",
        filterable: true,
        sortable: true,
        cell: (data) => {
          const now = moment.utc(this.props.current_time);
          const then = moment.utc(data.original.created_date);
          const elapsedTime = moment.duration(now.diff(then));
          const format = elapsedTime.asDays() > 1 ? "d hh:mm:ss" : "hh:mm:ss";
          return elapsedTime.format(format, { trim: false });
        },
      },
    ];

    const actions = [
      { id: "view", icon: "fa-eye", description: "View" },
      { id: "delete", icon: "fa-trash", description: "Delete" },
    ];

    const onAction = (action, item) => {
      switch (action) {
        case "view":
          this.props.history.push(`/viewkasm/${item.kasm_id}`);
        break;

        case "delete":
          this.deleteConfirm(item.kasm_id);
        break;
      }
    }

    return (
      <div className="profile-page">
        <BreadCrumbCompo routes={routes} />
        <Row>
          <Col sm={{ size: 10, order: 3, offset: 1 }}>
            <Card>
              <CardHeader>
              <div className="title-head">
                <i className="fa fa-table"></i> <strong>Sessions</strong></div>
              </CardHeader>
              <CardBody className="p-0">
                <DataTable
                  id="sessions"
                  data={kasms}
                  columns={tableColumns}
                  actions={actions}
                  onAction={onAction}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Modal
          isOpen={this.state.modal}
          toggle={this.cancelDelete}
          className="user-modal"
        >
          <ModalHeader toggle={this.cancelDelete}>
            Are you sure you want to delete this session?
          </ModalHeader>
          <ModalFooter>
            <Button onClick={this.cancelDelete} size="sm"
            className="cancel-button"
            color="basic"> Close</Button>
            {this.state.deleteClicked ? (
              <Spinner size="sm" color={"danger"} />
            ) : (
              <Button onClick={this.deleteKasmAction} 
              className="delete-button"
              size="sm" color="danger">
                {" "}
                 Delete
              </Button>
            )}
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

Kasms.propTypes = {
  getKasm: Proptypes.func.isRequired,
  kasms: Proptypes.array,
  current_time: Proptypes.string,
  destroyKasms: Proptypes.func,
  destroyKasmsErrorMessage: Proptypes.string,
  destroyKasmsError: Proptypes.string,
  getkasmLoading: Proptypes.bool,
  className: Proptypes.func,
  history: Proptypes.object,
  getKasmLoading: Proptypes.bool,
};

export default connect(
  (state) => {
    return ({
    kasms: state.kasms.kasms || [],
    current_time: state.kasms.current_time || null,
    getKasmLoading: state.kasms.getKasmLoading || false,
    destroyKasmsErrorMessage: state.images.destroyKasmsErrorMessage || null,
    destroyKasmsLoading: state.images.destroyKasmsLoading || false,
    destroyKasmsError: state.images.destroyKasmsError || null,
    pages : {pageSize : state.dashboard.pageSize, pageNo : state.dashboard.pageNo},

  })},
  (dispatch) => ({
    getKasm: () => dispatch(getKasm()),
    destroyKasms: (data) => dispatch(destroyKasms(data)),
    setPageInfo : (data)=> dispatch(setKasmPageInfo(data)),
  })
)(Kasms);



// WEBPACK FOOTER //
// ./src/views/Kasms/Kasm.js